import classNames from 'classnames'

type CustomRadioButtonProps = {
  name: string
  isSelected: boolean
  isInactive: boolean
}

const CustomRadioButton: React.FC<CustomRadioButtonProps> = ({
  name,
  isSelected,
  isInactive,
}) => {
  return (
    <div>
      <input
        id={name}
        name={name}
        type="radio"
        value="true"
        onChange={(e) => e.preventDefault()}
        checked={isSelected}
        disabled={isInactive}
        className={classNames(
          'h-6 w-6 opacity-0 absolute',
          !isInactive && 'cursor-pointer',
        )}
      />
      <div
        className={classNames(
          'bg-white border-1.5 border-gray-50 rounded-full h-6 w-6 flex shrink-0 justify-center items-center',
          isInactive ? 'border-secondary' : 'border-gray-light',
        )}
      >
        {isSelected && (
          <div
            className={classNames(
              'w-2 h-2 rounded-full',
              isInactive ? 'bg-secondary' : 'bg-primary',
            )}
          ></div>
        )}
      </div>
    </div>
  )
}

export default CustomRadioButton
